import React from 'react';

import appConfig from 'config/config';

import Button from 'b2b-ui-components-lib/lib/components/button';

import { redirectToTMO } from 'home/view/manage-feasibility/utils';

import { findParamFromUrl, convertTimeStamp } from 'common/utils/app.utils';

import { getProductDisplayName, getProductType, isAOIOrder } from 'common/constants/app.constants';

import greenCircle from '../images/green-circle.svg';
import tickIcon from '../images/tick-icon.svg';
import vpn from '../images/vpn.png';
import plan from '../images/plan.png';

import './thanks.scss';
import './ThanksAuth.scss';
import { redirectToTMODashboard } from 'home/view/manage-feasibility/utils/multiSite-utils';

const OtherProducts = () => (
  <div className="box-content">
    <h6>Check some other offers we have to serve you.</h6>
    <div className="row">
      <div className="flg-lg-6 flg-md-12">
        <div className="card">
          <div className="left-text">
            <h4>VPN </h4>
            <p>Ensure your company's work stays private and protected at all times with MPLS solution</p>
            <div className="more-link">
              <span>
                <a target="_blank" rel="noopener noreferrer" href="https://www.airtel.in/business/b2b/airtel-vpn">
                  Know More
                </a>
              </span>
            </div>
          </div>
          <figure className="image">
            <img src={vpn} alt="VPN" />
          </figure>
        </div>
      </div>
      <div className="flg-lg-6 flg-md-12">
        <div className="card">
          <div className="left-text">
            <h4>Airtel Corporate Postpaid Plans</h4>
            <p>Give your people the best mobile plan and business-grade service to collaborate on the go, seamlessly.</p>
            <div className="more-link">
              <span>
                <a target="_blank" rel="noopener noreferrer" href="https://www.airtel.in/business/b2b/postpaid-with-g-suite">
                  Know More
                </a>
              </span>
            </div>
          </div>
          <figure className="image">
            <img src={plan} alt="Airtel Plan" />
          </figure>
        </div>
      </div>
    </div>
  </div>
);

const ThankYouAuthPage = (props) => {
  const getProps = (props) => {
    if (props && props.location && props.location.state) {
      return props.location.state;
    }

    return props;
  };

  const { noNetwork = false, isMultiSite = false, leadId = '', userType = '', noOfCircuits = '', dateStamp = '', product, isUpgrade = false } = getProps(props);

  const showNoNetwork = noNetwork ? true : false;
  const currentProduct = product || getProductType();
  const productName = getProductDisplayName(currentProduct);
  const partyId = findParamFromUrl('partyId', false);

  const getMessageBody = () => {
    return `Your order for the ${isMultiSite ? 'multiple' : ''} Airtel ${productName} has been successfully submitted.`;
  };

  return (
    <div className="main-controller thanks-page thanks-page-auth">
      <section className="thanks-section">
        {showNoNetwork ? (
          <React.Fragment>
            <div className="container-old">
              <div className="head-area">
                <div className="thanks-heading">
                  <h3 className="danger-text">
                    Sorry! <br />
                    No network in the area.
                  </h3>
                </div>
                <p>Corporate {productName} Plan is not available in your area. For any queries, write to us at airtelforbusiness@airtel.com.</p>
                <p>
                  Booking order number: <strong>{leadId}</strong>
                </p>
              </div>
              <p>&nbsp;</p>
              <div className="buttonSection">
                <a className="track-link" href={redirectToTMODashboard()}>
                  Track Request
                </a>
                &nbsp;&nbsp;
                <a href={appConfig.aehdashboardUrl}>
                  <Button> Back to Home</Button>
                </a>
              </div>
            </div>
            <div className="container-old">
              <OtherProducts />
            </div>
          </React.Fragment>
        ) : (
          <div className="container-old">
            <div className="row">
              <div className="flg-lg-7 flg-md-12">
                <div className="main-section">
                  <div className="thanks-content">
                    <div className="head-title">
                      <div className="check-circle">
                        <img src={greenCircle} alt="green-circle" />
                        <img src={tickIcon} alt="✓" />
                      </div>

                      {userType === 'KAM' ? (
                        <span className="title-text">
                          Thank you! <br /> Request approved successfully.
                          {/* Thank you for choosing Airtel! */}
                        </span>
                      ) : isUpgrade ? (
                        <span className="title-text">Thank you for choosing Airtel!!</span>
                      ) : (
                        <span className="title-text">Your request has been raised successfully!</span>
                      )}

                      {userType === 'KAM' ? (
                        <React.Fragment>
                          <p className="title-subtext">
                            Order Request Number:{' '}
                            <a href="javascript:void(0)" onClick={() => redirectToTMO({ orderId: leadId })}>
                              {leadId}
                            </a>
                          </p>
                          <p className="title-subtext">Your booking order for the Airtel {productName} Plan has been approved.</p>
                        </React.Fragment>
                      ) : userType === 'ENTERPRISE' ? (
                        <React.Fragment>
                          <p className="title-subtext">
                            Order Request Number:{' '}
                            <a href="javascript:void(0)" onClick={() => redirectToTMO({ orderId: leadId })}>
                              {leadId}
                            </a>
                          </p>
                          <p className="title-subtext">{getMessageBody(currentProduct)}</p>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <p className="title-subtext">
                            Order Request Number : {''}
                            {currentProduct !== 'DSL' && (
                              <a href="javascript:void(0)" onClick={() => redirectToTMO({ orderId: leadId })}>
                                {leadId}
                              </a>
                            )}
                            {currentProduct === 'DSL' && <a href="javascript: void(0)">{leadId}</a>}
                          </p>
                          {isUpgrade ? (
                            <p className="title-subtext">
                              Your upgrade request for the multiple circuits of {productName} has been successfully submitted. An e-mail has been sent to you along with the pricing
                              quotation
                            </p>
                          ) : (
                            <p className="title-subtext">{getMessageBody(currentProduct)}</p>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </div>

                  <div className="buttonSection">
                    {userType !== 'ENTERPRISE' && currentProduct !== 'DSL' && (
                      <a className="track-order" href={partyId ? appConfig.kamTrackLeadPage + '?partyId=' + partyId : appConfig.kamTrackLeadPage}>
                        <Button>Track Order</Button>
                      </a>
                    )}
                    <a className="track-home" href={appConfig.aehdashboardUrl}>
                      <Button> {userType === 'ENTERPRISE' ? 'Go Back to Login' : 'Go Back to Home'}</Button>
                    </a>
                  </div>

                  <div className="bottom-section">
                    <div className="title">Request Details</div>
                    <div className="content">
                      <div className="box">
                        <span className="sub-heading">Number of Circuits</span>
                        <span className="value">{noOfCircuits || '-'}</span>
                      </div>
                      <div className="box">
                        <span className="sub-heading">Order ID</span>
                        <span className="value">{leadId || '-'}</span>
                      </div>
                      <div className="box">
                        <span className="sub-heading">Date &amp; time</span>
                        <span className="value">{convertTimeStamp(dateStamp) || '-'}</span>
                      </div>
                      {isUpgrade ? (
                        <div className="box">
                          <span className="sub-heading">Request Type</span>
                          <span className="value">Upgrade</span>
                        </div>
                      ) : (
                        <div className="box">
                          <span className="sub-heading">Request Type</span>
                          <span className="value">New Order</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {userType === 'KAM' ? (
                <div className="flg-lg-5 flg-md-12"></div>
              ) : (
                <div className="flg-lg-5 flg-md-12">
                  <div className="other-steps">
                    {!isUpgrade ? <div className="title">Next Steps</div> : null}
                    <ul className="steps-items">
                      {userType !== 'ENTERPRISE' && currentProduct !== 'DSL' ? (
                        <li>
                          <h4>KYC Verification</h4>
                          <p>As per TRAI regulations, our representative will fill your company details, take a photo of your company GSTN/PAN, POI and click your live photo.</p>
                        </li>
                      ) : (
                        <li>
                          <h4>Order Verification</h4>
                          <p>Our order verification team will process and verify the order details. We will notify you once the order is confirmed.</p>
                        </li>
                      )}
                      <li>
                        <h4>{productName} Installation</h4>
                        <p>Post successful verification, internet service will be installed, activated and ready to use.</p>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>

            <OtherProducts />
          </div>
        )}
      </section>
    </div>
  );
};

export default ThankYouAuthPage;
